<template>
  <div v-if="demoStore.active" class="demo-banner" role="status">
    <span class="demo-dot" aria-hidden="true"></span>
    <span class="demo-label">{{ t('demo.banner.label') }}</span>
    <span class="demo-sep" aria-hidden="true">·</span>
    <span class="demo-time">{{
      t('demo.banner.minutesLeft', { count: demoStore.minutesLeft })
    }}</span>

    <div class="demo-actions">
      <button type="button" class="demo-btn demo-btn-ghost" @click="resetDemo">
        {{ t('demo.banner.reset') }}
      </button>
      <a :href="contactUrl" target="_blank" rel="noopener" class="demo-btn demo-btn-cta">
        {{ t('demo.banner.contact') }}
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useDemoStore } from '@/stores/demo'
import { useI18n } from '@/composables/useI18n'

const demoStore = useDemoStore()
const { t } = useI18n()

// Conversion lever: pricing is hidden, so the CTA books a demo / contacts sales.
// Configure VITE_DEMO_CONTACT_URL (WhatsApp / Calendly / mailto) per deploy.
const contactUrl = import.meta.env.VITE_DEMO_CONTACT_URL || 'mailto:hello@hudstore.studio'

// Re-bootstrap a fresh demo workspace by reloading the boot route.
const resetDemo = () => {
  window.location.href = '/demo'
}
</script>

<style scoped>
.demo-banner {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.5rem 1rem;
  background: #2a0b11;
  color: #f5e9dc;
  font-size: 0.875rem;
  font-weight: 500;
  letter-spacing: 0.01em;
}
.demo-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #e4b9c2;
  animation: demo-blink 1.6s ease-in-out infinite;
}
@keyframes demo-blink {
  0%,
  100% {
    opacity: 0.4;
  }
  50% {
    opacity: 1;
  }
}
.demo-label {
  font-weight: 600;
}
.demo-sep {
  opacity: 0.5;
}
.demo-time {
  font-variant-numeric: tabular-nums;
  opacity: 0.9;
}

.demo-actions {
  margin-left: auto;
  display: flex;
  gap: 0.5rem;
}
.demo-btn {
  border: 0;
  border-radius: 4px;
  padding: 0.3rem 0.75rem;
  font-size: 0.8125rem;
  font-weight: 600;
  cursor: pointer;
  background: #e4b9c2;
  color: #2a0b11;
  transition: background 0.15s ease;
}
.demo-btn:hover {
  background: #f5c5d2;
}
.demo-btn-ghost {
  background: transparent;
  color: #f5e9dc;
  border: 1px solid rgba(245, 233, 220, 0.4);
}
.demo-btn-ghost:hover {
  background: rgba(245, 233, 220, 0.12);
}
.demo-btn-cta {
  background: #f5c5d2;
  color: #2a0b11;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
}
.demo-btn-cta:hover {
  background: #fff;
}

@media (max-width: 600px) {
  .demo-banner {
    font-size: 0.8125rem;
    gap: 0.4rem;
    padding: 0.45rem 0.75rem;
  }
  .demo-label {
    display: none;
  }
}
</style>
